export default __webpack_public_path__ + "static/media/foot-left-inside.f315c1fc.png";